/* eslint-disable global-require */
import angular from 'angular';

class StaticLinkController {
  private staticId!: string;

  public src = '';

  public $onInit = (): void => {
    const BASE_URL = `${API_URL}/static/f/view`;
    this.src = `${BASE_URL}/${this.staticId}`;
  };
}

export const StaticLinkComponent = {
  selector: 'staticLink',
  bindings: {
    staticId: '<',
    text: '<',
  },
  replace: true,
  template: /* html */ `
    <a ng-href="{{ $ctrl.src }}" target="_blank">{{ $ctrl.text }}</a>
  `,
  controller: StaticLinkController,
};

export default angular.module('autoboard.staticLink', [])
  .component(StaticLinkComponent.selector, StaticLinkComponent)
  .name;
